import {createFileRoute} from '@tanstack/react-router';

import {siteKeys} from '@/features/Site/api/queryKeys';
import {getSite} from '@/features/Site/api/readSite';
import {UpdateSiteForm} from '@/features/Site/components/UpdateSiteForm';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/sites/update/$siteId')({
  component: UpdateSiteForm,

  beforeLoad: ({params, context}) => {
    makeDocumentTitle(`Edit ${params.siteId}`);

    return {
      ...context,
      readSiteQuery: {
        queryKey: siteKeys.detail(params.siteId),
        queryFn: () => getSite(params.siteId),
      },
    };
  },

  loader({context}) {
    return context.queryClient.ensureQueryData(context.readSiteQuery);
  },
});
